var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-container tw-h-full"},[_c('div',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"card-body"},[_vm._t("body")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }